import {createAction} from 'redux-act';
import {IArticleTarget} from '@app-types/article.types';

export const readArticle = createAction<number>('Read ArticleId');
export const openArticle = createAction<IArticleTarget>('Open article modal');
export const closeArticle = createAction('Close article modal');
export const browseInArticleViewer = createAction<{path: string; country?: string}>('Browse in article modal');



// WEBPACK FOOTER //
// ./src/services/article/article.actions.ts